import {
    Component,
    Input,
    Output,
    HostBinding,
    EventEmitter,
    forwardRef,
    ViewChild,
    ElementRef
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
} from '@angular/forms';
import { MatSelect } from '@angular/material/select';
@Component({
    selector: 'app-select',
    templateUrl: './select.component.pug',
    styleUrls: ['./select.component.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectComponent),
        multi: true
    }]
})
export class SelectComponent implements ControlValueAccessor {
    @HostBinding('attr.value') attrValue: string;

    @Input() panelClass: string[] = [''];

    _value: string;
    @Input() set value(value: string) {
        this._value = value;
        this.attrValue = value;
    }
    get value(): string {
        return this._value;
    }
    @Input() options: string[];
    @Output() change: EventEmitter<string> = new EventEmitter();

    @ViewChild('select', {static: true}) selectRef: MatSelect;

    @Input() disableOptionCentering = false;

    get isOpen(): boolean {
        return this.selectRef.panelOpen;
    }

    constructor(
    ) {
    }

    onChange(value: string) {
        this.value = value;

        this.change.emit(this.value);
        this.propagateChange(this.value);

        this.selectRef.close();
    }

    onOpen() {
        this.selectRef.open();
    }

    // START: ControlValueAccessor Interface
    writeValue(value: string) {
        this.value = value;
    }

    propagateChange = (_: any) => {
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }
    // END: ControlValueAccessor Interface
}
